import { TableHead, TableRow, TableCell } from "@mui/material"
import { useTranslation } from "react-i18next"

type Header = {
  label: string;
  text: string;
}

type Props = {
  def: Array<Header>;
}

const TableHeader: React.FC<Props> = ({ def }) => {
  const { t } = useTranslation('dashboard')

  return (
    <TableHead>
      <TableRow sx={{ backgroundColor: 'rgb(20, 30, 56)' }}>

        {def.map((item, i) => {
          return (
            <TableCell sx={{ fontSize: "1.3rem", color: 'white' }} key={i}>{t(`${item.text}`)}</TableCell>
          )
        })}

      </TableRow >
    </TableHead >
  )
}

export default TableHeader;